module.exports = __webpack_public_path__ + "assets/img/video.69a0d8c5.png";